module.exports = __webpack_public_path__ + "img/9788954428217.64e9bd31.jpg";